module.exports = __webpack_public_path__ + "resources/img/banner-4.c751a06f.jpg";